export default __webpack_public_path__ + "static/media/BurialEnclosure.28c527c4.mp3";